module.exports = __webpack_public_path__ + "static/media/hab5-1.a4c5e91b.jpg";